export class TaskAllowedTask {
	public index;
	
	constructor(obj) {
		this.index = obj.index;
	}
} 
